import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { FirstRunExperienceDialogProps } from './FirstRunExperienceDialog';

const firstRunExperienceDialog = () => import(/* webpackChunkName: "4-feat-fre" */ './FirstRunExperienceDialog');

const LoadableFirstRunExperienceDialog: ComponentType<FirstRunExperienceDialogProps> =
  lazyLoadOnRender<FirstRunExperienceDialogProps>({ loader: firstRunExperienceDialog });
export default LoadableFirstRunExperienceDialog;
